import { PriseRdvData } from '../types/VisitesTypes'
import { ConfirmationPriseRendezVous } from '../types/calendrierVisiteModel'
import { RefusRendezVous } from '../types/refusRDVModel'
import axios from 'axios'

export const priseRDV = (data: PriseRdvData) => axios.post(
	'/api/sitel/rendezvous/horairesRdv',
	data
).then((response) => response.data)

export const confirmerRDV = (data: ConfirmationPriseRendezVous) => axios.post(
	'/api/sitel/rendezvous/priseRdv',
	data
).then((response) => response.data)

export const offresVisitesResidence = (crm_id?: string) => axios(`/api/sitel/getVisitesResidence${crm_id && crm_id.length ? `?crm_id=${crm_id}` : ''}`)
	.then((response) => response.data)

export const refuserRDV = (data: RefusRendezVous) => axios.post('/api/sitel/rendezvous/refusRdv', data)
	.then((response) => response.data)